module.exports = __webpack_public_path__ + "img/result_ls_lens_up_angle.978b85cc.jpg";